const { PanelBody, Panel, PanelRow, ColorPicker } = wp.components;
const { InnerBlocks, InspectorControls } = wp.blockEditor;

export default ({ attributes, setAttributes }) => {
	const { buttonColor, buttonTextColor, buttonHoverColor, buttonHoverTextColor } = attributes;

	return (
		<>
			<InspectorControls>
			<Panel header="Botão de enviar">
				<PanelBody title="Normal">
					<PanelRow>Cor de fundo</PanelRow>
					<ColorPicker
						color={buttonColor}
						onChangeComplete={(value) => setAttributes({ buttonColor: value })}
						/>

					<PanelRow>Cor do texto</PanelRow>
					<ColorPicker
						color={buttonTextColor}
						onChangeComplete={(value) => setAttributes({ buttonTextColor: value })}
					/>
				</PanelBody>
				<PanelBody title="Hover">
					<PanelRow>Cor de fundo</PanelRow>
					<ColorPicker
						color={buttonHoverColor}
						onChangeComplete={(value) => setAttributes({ buttonHoverColor: value })}
					/>
					<PanelRow>Cor do texto</PanelRow>
					<ColorPicker
						color={buttonHoverTextColor}
						onChangeComplete={(value) => setAttributes({ buttonHoverTextColor: value })}
					/>
				</PanelBody>
			</Panel>
			</InspectorControls>
			<div className="WPForm WPForm-email">
				<InnerBlocks
					allowedBlocks={[
						'wpforms/form-selector'
					]}
				/>
				<style>
					{`
						.WPForm-email .wpforms-submit-container button {
							color: ${ buttonTextColor.hex } !important;
							background-color: ${ buttonColor.hex } !important;
						}

						.WPForm-email .wpforms-submit-container button:hover {
							color: ${ buttonHoverTextColor.hex } !important;
							background: ${ buttonHoverColor.hex } !important;
						}
					`}
				</style>
			</div>
		</>
	);
};
